import axios from "axios";

export const getBackendOrigin = () => {
  if (typeof window !== "undefined") {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return window.location.port === "5173" ? "http://localhost:3001" : window.location.origin;
    }
    return "https://api.goldpe.tech";
  }
  return "https://api.goldpe.tech";
};

export const DEPLOYED_BACKEND_URL = "https://api.goldpe.tech";
export const LOCAL_BACKEND_URL = typeof window !== "undefined" ? window.location.origin : "http://localhost:3001";

const isLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
const BASE_URL = isLocal ? "http://localhost:3001/api" : "https://api.goldpe.tech/api";

const api = axios.create({ 
  baseURL: BASE_URL,
  withCredentials: true
});

export function getImageUrl(path) {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) return path;
  
  if (!path.includes("/")) {
    path = `/uploads/${path}`;
  }
  
  const origin = getBackendOrigin();
  return `${origin}${path.startsWith("/") ? "" : "/"}${path}`;
}

// Auto-attach JWT token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 — clear token
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("fp_token");
      localStorage.removeItem("fp_user");
    }
    return Promise.reject(err);
  }
);

export { api };
export default api;
